module.exports = __webpack_public_path__ + "@/assets/img/quarters-icon.a0310482.svg";